import React, { useEffect, useState } from 'react'
import { differenceInDays } from 'date-fns'

type Props = {
  title: string
  path: string
  children: (state: { href: string }) => React.ReactElement<any>
}

export default function HackerNewsLink({ path, title, children }: Props) {
  // By default, make people submit the link to HackerNews when clicking "Discuss on HackerNews"
  const [href, setHref] = useState(
    `https://news.ycombinator.com/submitlink?u=${encodeURIComponent(
      `https://stellate.co${path}/`,
    )}&t=${encodeURIComponent(title)}`,
  )

  // Asynchronously check if the link has already been submitted and link to the most upvoted submission instead
  useEffect(() => {
    fetch(
      `https://hn.algolia.com/api/v1/search?tags=story&restrictSearchableAttributes=url&query=${encodeURIComponent(
        `https://stellate.co${path}/`,
      )}`,
    )
      .then((res) => res.json())
      .then((res) => {
        if (!res || !Array.isArray(res.hits) || res.hits.length === 0) return
        // If it hasn't been submitted in a year and wasn't on the frontpage let's recommend submitting again
        // (crude estimate of frontpage = >50 points, also see https://news.ycombinator.com/newsfaq.html for resubmit rules)
        if (
          res.hits.every(
            (hit) =>
              hit.points < 50 &&
              differenceInDays(new Date(hit.created_at), new Date()) > 365,
          )
        ) {
          return
        }

        // Find the most upvoted post of this link
        const beloved = res.hits.reduce((a, b) => {
          if (a.points > b.points) return a
          return b
        }, res.hits[0])

        setHref(`https://news.ycombinator.com/item?id=${beloved.objectID}`)
      })
      .catch((err) => {
        console.error(err)
      })
  }, [path])

  return children({ href })
}
